import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';

import './style.css';
import Legal from './views/legal';
import Home from './views/home';
import Blog from './views/blog';
import BlogPost from './views/blog-post';
import NotFound from './views/not-found';

const POSTHOG_KEY = 'phc_HrnfWo1qZfeiNOYqPGGL116kcP7YaBQeaGsFDo3fyNW';
const POSTHOG_HOST = 'https://us.i.posthog.com';

const options = {
  api_host: POSTHOG_HOST,
  defaults: '2025-05-24',
};

const App = () => {
  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      <Router>
        <Switch>
          <Route component={Legal} exact path='/legal' />
          <Route component={BlogPost} exact path='/blog/:slug' />
          <Route component={Blog} exact path='/blog' />
          <Route component={Home} exact path='/' />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </PostHogProvider>
  );
};

const rootElement = document.getElementById('app');

if (rootElement) {
  ReactDOM.render(<App />, rootElement);
}
